import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { buttonStyles } from '@/components/ui'

interface MobileMenuProps {
  isOpen: boolean
  onClose: () => void
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      />

      {/* Menu */}
      <div className="fixed top-0 right-0 h-full w-80 max-w-[90vw] bg-white z-50 shadow-xl overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <span className="font-semibold text-gray-800">Menu</span>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          {/* Tools */}
          <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider px-3 pt-2 pb-1">
            Tools
          </div>

          <Link
            to="/check"
            onClick={onClose}
            className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-800">AI Detector</span>
          </Link>

          <Link
            to="/undetectable"
            onClick={onClose}
            className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-800">Make Undetectable</span>
          </Link>

          <Link
            to="/enhance-realism"
            onClick={onClose}
            className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-800">Enhance Realism</span>
          </Link>

          <Link
            to="/tools/metadata-cleaner"
            onClick={onClose}
            className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-800">Metadata Cleaner</span>
          </Link>

          {/* Benchmark */}
          <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider px-3 pt-4 pb-1">
            Benchmark
          </div>

          <Link
            to="/"
            onClick={onClose}
            className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-800">Detector Rankings</span>
          </Link>

          <Link
            to="/arena"
            onClick={onClose}
            className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <span className="font-medium text-gray-800">Arena</span>
          </Link>

        </nav>

        {/* CTA */}
        <div className="p-4 border-t border-gray-200">
          <Link to="/" onClick={onClose} className={buttonStyles({ className: 'w-full' })}>
            Try Free
          </Link>
        </div>
      </div>
    </>
  )
}
